import "./FriosTitulos.css";

export default function FriosTitulos({ title }) {
  return (
    <section className="foodpart04-title">
      <h2>{title}</h2>
    </section>
  );
}
